import { render } from "./App.vue?vue&type=template&id=37141fb6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=37141fb6&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__